module.exports = __webpack_public_path__ + "img/5-TWK-Populated-Details-Page.cc1b77e2.png";